export default "__VITE_ASSET__CZkQiFB9__"